/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ModuloAggiuntivoCorpoCountDto } from '../../models/modulo-aggiuntivo-corpo-count-dto';

export interface ApiModuloAggiuntivoCorpoWithCountListGet$Params {}

export function apiModuloAggiuntivoCorpoWithCountListGet(
    http: HttpClient,
    rootUrl: string,
    params?: ApiModuloAggiuntivoCorpoWithCountListGet$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<Array<ModuloAggiuntivoCorpoCountDto>>> {
    const rb = new RequestBuilder(rootUrl, apiModuloAggiuntivoCorpoWithCountListGet.PATH, 'get');
    if (params) {
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Array<ModuloAggiuntivoCorpoCountDto>>;
        }),
    );
}

apiModuloAggiuntivoCorpoWithCountListGet.PATH = '/api/modulo-aggiuntivo/corpo-with-count-list';
